import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DirectiveRoutingModule } from './directive-routing.module';
import { GetTitleDirective } from './get-title/get-title.directive';

@NgModule({
  declarations: [GetTitleDirective],
  imports: [CommonModule, DirectiveRoutingModule],
  providers: [{ provide: GetTitleDirective }],
})
export class DirectiveModule {}
